import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Loading fallback component for Suspense boundaries
 * Displays a centered loading spinner while lazy components are loading
 */
export const LoadingFallback = (props: { className?: string }) => {
  const { className } = props;
  return (
    <div
      className={cn(
        'flex size-full min-h-0 items-center justify-center',
        className,
      )}
    >
      <Loader2 className="text-primary size-20 animate-spin" />
    </div>
  );
};
